'use client';

import { useToast } from '@common/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { AuthMutation } from '@/api';

// 댓글 삭제 후 관련 목록 캐시를 정리하는 공통 훅이다.
export const useDeleteCommentMutation = () => {
  const { toastError } = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    ...AuthMutation['put:/wello/v2/auth/wello-comment/{welloCommentId}/delete'](),
    onError: (error) => {
      toastError({ error });
    },
    onSuccess: async () => {
      // 삭제 후에도 작성/수정과 동일하게 전체 캐시 기준으로 동기화한다.
      await queryClient.invalidateQueries();
    },
  });
};
